module.exports = __webpack_public_path__ + "img/innovations.0f36ee43.webp";